import LinkedActivityForm from '../forms/linkedActivityForm';
/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from 'react';

import { Dropdown, Modal, Button, Icon } from 'semantic-ui-react';
import { stopPropagation } from '../../../../../../utils';
import { useTranslation } from 'react-i18next';

export default function CreateLinkedActivity(props) {
  const { t } = useTranslation();
  const {
    currentState,
    reSetFilters,
    textLabel,
    modalLabel,
    activityPlanTypeId,
    parentActivityPlanTypeId,
    isMultiLevelIncluded = true,
  } = props;
  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <Modal
      trigger={
        isMultiLevelIncluded ? (
          <Dropdown.Item
            onClick={() => {
              toggle();
            }}
          >
            {textLabel}
          </Dropdown.Item>
        ) : (
          <Button onClick={() => toggle()} className="Secondary-Button">
            <Icon name="plus" />
            {t('activity.activity_plan.linked_activity.add_modal_label', {
              label: modalLabel,
            })}
          </Button>
        )
      }
      size="small"
      open={modal}
      onClick={(e) => stopPropagation(e)}
      onFocus={(e) => stopPropagation(e)}
      className="evaluation-model"
    >
      <Modal.Header className="goal-confirm-modal-header">
        <div className="modal-heading">
          {t('activity.activity_plan.linked_activity.create_new_modal_label', {
            label: modalLabel,
          })}
        </div>
        <div className="slim-close-icon" onClick={() => toggle()}>
          &times;
        </div>
      </Modal.Header>
      <Modal.Content>
        <LinkedActivityForm
          reSetFilters={reSetFilters}
          toggle={toggle}
          currentState={currentState}
          activityPlanTypeId={activityPlanTypeId}
          parentActivityPlanTypeId={parentActivityPlanTypeId}
        />
      </Modal.Content>
    </Modal>
  );
}
